var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80193 0.643903C6.86428 0.452032 7.13572 0.452032 7.19807 0.643903L8.58974 4.92702C8.61762 5.01283 8.69758 5.07093 8.7878 5.07093H13.2913C13.4931 5.07093 13.577 5.32909 13.4138 5.44767L9.77031 8.09479C9.69732 8.14782 9.66678 8.24182 9.69466 8.32763L11.0863 12.6107C11.1487 12.8026 10.9291 12.9622 10.7659 12.8436L7.12241 10.1965C7.04942 10.1434 6.95058 10.1434 6.87759 10.1965L3.23415 12.8436C3.07093 12.9622 2.85133 12.8026 2.91367 12.6107L4.30534 8.32763C4.33322 8.24182 4.30268 8.14782 4.22969 8.09479L0.586246 5.44767C0.423031 5.32909 0.506913 5.07093 0.708658 5.07093H5.2122C5.30242 5.07093 5.38238 5.01283 5.41026 4.92702L6.80193 0.643903Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.92899652.svg";
export { ForwardRef as ReactComponent };